// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-button-group[data-v-0277ba03] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: 20px;\n  height: 40px !important;\n}\n.bottom-button-group > .left[data-v-0277ba03] {\n  margin-right: 5px;\n}\n.bottom-button-group .right[data-v-0277ba03] {\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
